import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[lingua-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: LinguaValidatorDirective, multi: true }]
})
export class LinguaValidatorDirective implements Validator {

  constructor() { }

  validate(c: FormControl): ValidationErrors {
    // console.log('lingua-validator', c.value);
    const isValid =
      c.value
      && c.value.tipologia
      && c.value.lingua;
    const message = {
      'lingua': {
        'message': 'Specificare entrambi i campi'
      }
    }
    return isValid ? null : message;
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/lingua-validator.directive.ts